import { Stack } from '@mantine/core'
import { Claim } from '../../types/claim'
import { ClaimCard } from './ClaimCard'

export interface ClaimsListProps {
  claims: Claim[]
  onConnect: (claimNumber: string) => void
  highlightClaimNumber?: string
  connectedClaimNumber?: string
}

export function ClaimsList({
  claims,
  onConnect,
  highlightClaimNumber,
  connectedClaimNumber,
}: Readonly<ClaimsListProps>) {
  return (
    <Stack gap="xs">
      {claims.map((claim) => (
        <ClaimCard
          key={claim.claimNumber}
          claim={claim}
          onConnect={onConnect}
          highlighted={highlightClaimNumber === claim.claimNumber}
          connected={connectedClaimNumber === claim.claimNumber}
        />
      ))}
    </Stack>
  )
}
